const PENDING_INVITE_KEY = "m4mmon_pending_invite";

export type PendingInvite = { code: string; email: string | null };

export function readPendingInvite(): PendingInvite | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(PENDING_INVITE_KEY) ?? "null") as Partial<PendingInvite> | null;
    return value && typeof value.code === "string" && (typeof value.email === "string" || value.email === null)
      ? { code: value.code, email: value.email }
      : null;
  } catch {
    return null;
  }
}

export function storePendingInvite(invite: PendingInvite) {
  sessionStorage.setItem(PENDING_INVITE_KEY, JSON.stringify(invite));
}

export function clearPendingInvite() {
  sessionStorage.removeItem(PENDING_INVITE_KEY);
}
